<template>
  <div class="layout__header">
    <div class="cms__logo">
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="less" scoped>
.layout__header{
  height: 100%;
  background-color: #2c2d2f;
}
.cms__logo{
  height: 48px;
  img{
    height: 100%;
  }
}
</style>